import React from 'react';
import { useImpersonation } from '@hooks/useImpersonation';
import { useAuthContext } from '@contexts/AuthContext';
import { useLanguage } from '@contexts/LanguageContext';
import Button from '@components/common/Button';

const UserImpersonationButton = ({
  userId,
  userName,
  disabled = false,
  size = "small",
  variant = "secondary"
}) => {
  const { startImpersonation, loading, canImpersonate } = useImpersonation();
  const { user } = useAuthContext();
  const { t } = useLanguage();

  // N'afficher que si l'utilisateur peut impersonner
  if (!canImpersonate) {
    return null;
  }

  // Désactiver si c'est l'utilisateur courant
  const isCurrentUser = user?.id === userId;
  const isDisabled = disabled || isCurrentUser;

  const handleImpersonate = () => {
    if (isCurrentUser) {
      return; // Ne rien faire si c'est l'utilisateur courant
    }

    const confirmMessage = t('admin.impersonation.confirm.message', { userName });

    if (window.confirm(confirmMessage)) {
      startImpersonation(userId);
    }
  };

  const buttonText = isCurrentUser
    ? t('admin.impersonation.button.you')
    : t('admin.impersonation.button.impersonate');

  const buttonTitle = isCurrentUser
    ? t('admin.impersonation.button.tooltip_self')
    : t('admin.impersonation.button.tooltip_impersonate', { userName });

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleImpersonate}
      loading={loading}
      disabled={isDisabled}
      title={buttonTitle}
    >
      {buttonText}
    </Button>
  );
};

export default UserImpersonationButton;
